<template>
  <div class="data-bar-info">
    <h5>{{participation.cms_establishment_name}}</h5>
    <h6>{{ participation.cms_city }}</h6>
  </div>
</template>

<script>

export default {
  name: 'VideoCardHeader',
  props: {
    participation: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.data-bar-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  margin-bottom: 0.25rem;
  color: var(--primary);
}
.data-bar-info h5 {
  font-weight: 500;
  margin-bottom: -0.25rem;
}
.data-bar-info h6 {
  font-weight: 500;
  margin-top: -0.25rem;
}
</style>
